import { FC } from 'react'
import { Radio } from '@pepper/ui'

import { StringParam, useQueryParams, withDefault } from 'use-query-params'

import s from './Sort.module.css'

type Props = {
  isSuggested: boolean
}

export const Sort = ({ isSuggested }: Props) => {
  const [query, setQuery] = useQueryParams({
    sort: withDefault(StringParam, undefined),
  })

  return (
    <div className={s.wrapper}>
      <div className={s.title}>Sort By</div>
      <Radio
        value="expected_traffic"
        checked={query.sort === 'expected_traffic_start:desc'}
        onChange={() => {
          setQuery({
            sort: 'expected_traffic_start:desc',
          })
        }}
      >
        Expected Traffic
      </Radio>
      <Radio
        value="none"
        defaultChecked={true}
        checked={query.sort === undefined}
        onChange={() =>
          setQuery({
            sort: undefined,
          })
        }
      >
        {isSuggested ? 'Default' : 'Latest Added'}
      </Radio>
    </div>
  )
}
